














/* General */
import Vue from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */
import AddGuestForm from './components/add-guest-form.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'GuestsCreate',

  metaInfo: {
    title: 'Invite New Guest',
  },

  components: {
    CardCanvas,
    AddGuestForm,
  },

  data() {
    return {
      RouteAssistant,
    }
  },
})
